import { lazy } from 'react';
/**swp00092 */
const EC_Upd_Mod_swp00092 = lazy(() => import('./emerg_contacts/swp00092/ec_upd_swp00092'));
const EC_Upd_Mod_tst00092 = lazy(() => import('./emerg_contacts/tst00092/ec_upd_tst00092'));
const Dep_List_swp00092 = lazy(() => import('./dependents/swp00092/dep_list_swp00092'));
const Dep_Upd_swp00092 = lazy(() => import('./dependents/swp00092/dep_upd_swp00092'));
const Dep_List_tst00092 = lazy(() => import('./dependents/tst00092/dep_list_tst00092'));
const Dep_Upd_tst00092 = lazy(() => import('./dependents/tst00092/dep_upd_tst00092'));
/**swp00073 */
const Dep_Upd_swp00073 = lazy(() => import('./dependents/swp00073/dep_upd_swp00073'));
const Per_List_swp00073 = lazy(() => import('./personal_data/swp00073/per_list_swp00073'));
const personal_data_edit_swp00073 = lazy(() => import('./personal_data/swp00073/personal_data_edit_swp00073'));
const Per_List_tst00073 = lazy(() => import('./personal_data/tst00073/per_list_tst00073'));
const personal_data_edit_tst00073 = lazy(() => import('./personal_data/tst00073/personal_data_edit_tst00073'));

const Dep_Upd_swp00129 = lazy(() => import('./dependents/swp00129/dep_upd_swp00129'));
const Dep_Upd_swp00122 = lazy(() => import('./dependents/swp00122/dep_upd_swp00122'));
const Dep_Upd_mjh00001 = lazy(() => import('./dependents/mjh00001/dep_upd_mjh00001'));
const Dep_Upd_swp00115 = lazy(() => import('./dependents/swp00115/dep_upd_swp00115'));
const Dep_Upd_tst00073 = lazy(() => import('./dependents/tst00073/dep_upd_tst00073'));
const Dep_Upd_tst00129 = lazy(() => import('./dependents/tst00129/dep_upd_tst00129'));
const Dep_Upd_tst00122 = lazy(() => import('./dependents/tst00122/dep_upd_tst00122'));
const Dep_Upd_mjt00001 = lazy(() => import('./dependents/mjt00001/dep_upd_mjt00001'));
const Dep_Upd_tst00115 = lazy(() => import('./dependents/tst00115/dep_upd_tst00115'));

const W2h_swp00037 = lazy(() => import('./w2_history/swp00037/w2h_swp00037'));

const BenefitStatement_swp00073 = lazy(() => import('./benefit_statement/swp00073/benefit_statement_swp00073'));
const BenefitStatement_tst00073 = lazy(() => import('./benefit_statement/tst00073/benefit_statement_tst00073'));
const BenefitStatement_swp00114 = lazy(() => import('./benefit_statement/swp00114/benefit_statement_swp00114'));
const BenefitStatement_tst00114 = lazy(() => import('./benefit_statement/tst00114/benefit_statement_tst00114'));
/**Paycheck Calculator */
const PaycheckCalculator_swp00073 = lazy(() => import('./paycheck_calculator/swp00073/paycheck_calculator_swp00073'));
const PaycheckCalculator_tst00073 = lazy(() => import('./paycheck_calculator/tst00073/paycheck_calculator_tst00073'));
const PaycheckCalculatorResult_swp00117 = lazy(() => import('./paycheck_calculator/swp00117/paycheck_calculator_result_swp00117'));
const PaycheckCalculatorResult_tst00117 = lazy(() => import('./paycheck_calculator/tst00117/paycheck_calculator_result_tst00117'));
/**Address Information */
const Address_Information_swp00073 = lazy(() => import('./address_information/swp00073/add_info_swp00073'));
const ADDINFOUPD_swp00073 = lazy(() => import('./address_information/swp00073/Add_info_upd_swp00073'));
const Address_Information_tst00073 = lazy(() => import('./address_information/tst00073/add_info_tst00073'));
const ADDINFOUPD_tst00073 = lazy(() => import('./address_information/tst00073/Add_info_upd_tst00073'));
const Payroll_Information_swp00073 = lazy(() => import('./payroll_information/swp00073/Payroll_Information_swp00073'));
const Payroll_Information_tst00073 = lazy(() => import('./payroll_information/tst00073/Payroll_Information_tst00073'));
/**Education */
const AddDetail_tst00073 = lazy(() => import('./ee_education/tst00073/ee_addedit_tst00073'));
/**E-Mail Address */
const Email_Address_swp00073 = lazy(() => import('./email_address/swp00073/email_address_swp00073'));
const EMailAddrAddUpdate_swp00073 = lazy(() => import('./email_address/swp00073/email_address_upd_swp00073'));
const Email_Address_tst00073 = lazy(() => import('./email_address/tst00073/email_address_tst00073'));
const EMailAddrAddUpdate_tst00073 = lazy(() => import('./email_address/tst00073/email_address_upd_tst00073'));
/**Employee Direcotry */
const Employee_Directory_tst00073 = lazy(() => import('./employee_directory/tst00073/employee_directory_tst00073'));
/**First Time Enrollment */
const BenefitsFTEMenu_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_menu_swp00073'));
const BenefitsFTEPrsonalInfo_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_personal_info_swp00073'));
const BenefitsFTEDependents_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_dependents_swp00073'));
const BenefitsFTEVerify_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_verify_swp00073'));
const BenefitsFTEElectBenefits_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_elect_benefits_swp00073'));
const BenefitsFTEReviewBenefits_swp00073 = lazy(() => import('./first_time_enrollment/benefits_FTE_review_swp00073'));



export const modComponentsModules = {
  /**Emergency contacts mods */
  EC_Upd_Mod_swp00092,
  EC_Upd_Mod_tst00092,
  /**Dependents contacts mods */
  Dep_List_swp00092,
  Dep_Upd_swp00092,
  Dep_List_tst00092,
  Dep_Upd_tst00092,
  Dep_Upd_swp00129,
  Dep_Upd_swp00122,
  Dep_Upd_mjh00001,
  Dep_Upd_swp00115,
  Dep_Upd_swp00073,
  Dep_Upd_tst00129,
  Dep_Upd_tst00122,
  Dep_Upd_mjt00001,
  Dep_Upd_tst00115,
  Dep_Upd_tst00073,
  /**W2History Mods */
  W2h_swp00037,
  /**Education Mods */
  /**Person Data */
  Per_List_swp00073,
  personal_data_edit_swp00073,
  Per_List_tst00073,
  personal_data_edit_tst00073,
  /**Benefit Statement */
  BenefitStatement_swp00073,
  BenefitStatement_tst00073,
  BenefitStatement_swp00114,
  BenefitStatement_tst00114,
  /**Paycheck Calculator */
  PaycheckCalculator_swp00073,
  PaycheckCalculator_tst00073,
  PaycheckCalculatorResult_swp00117,
  PaycheckCalculatorResult_tst00117,
  /**Address Information */
  Address_Information_swp00073,
  ADDINFOUPD_swp00073,
  Address_Information_tst00073,
  ADDINFOUPD_tst00073,
  Payroll_Information_swp00073,
  Payroll_Information_tst00073,
  /**Education */
  AddDetail_tst00073,
  /**E-Mail Address */
  Email_Address_swp00073,
  EMailAddrAddUpdate_swp00073,
  Email_Address_tst00073,
  EMailAddrAddUpdate_tst00073,
  /**Employee Direcotry */
  Employee_Directory_tst00073,
  /**First Time Enrollment */
  BenefitsFTEMenu_swp00073,
  BenefitsFTEPrsonalInfo_swp00073,
  BenefitsFTEDependents_swp00073,
  BenefitsFTEVerify_swp00073,
  BenefitsFTEElectBenefits_swp00073,
  BenefitsFTEReviewBenefits_swp00073,
};